export default "__VITE_ASSET__BT3Luyjy__"